import { createSlice } from '@reduxjs/toolkit';
import apiFacebook from '../../api/facebook';
import { param } from 'jquery';
import { message } from 'antd';
// utils
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  error: false,
  comments: [],
  commentReplies: [],
  posts: [],
  selectedPost: null,
  pageSelected: []
};
//
// name : teen store quan li
const slice = createSlice({
  name: 'post_facebook',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // ACCESS ZALO
    statusGetPostsSuccess(state, action) {
      const participants = action.payload;
      state.posts = participants;
      state.isLoading = false;
    },
    statusGetCommentSuccess(state, action) {
      const participants = action.payload;
      state.comments = participants;
      state.commentReplies = [];
      state.isLoading = false;
    },
    // ACCESS ZALO
    statusGetViewReplieSuccess(state, action) {
      const participants = action.payload;
      state.commentReplies = state.commentReplies.concat(participants)
      state.isLoading = false;
    },
    statusSelectedPostSuccess(state, action) {
      const participants = action.payload;
      if (participants) {
        var index = state.posts.findIndex(function (post) {
          return post.post_id === participants.post_id;
        });

        if (index !== -1) {
          state.posts[index].is_read = 1
        }
        state.selectedPost = participants;
      } else {
        state.selectedPost = null;
      }


      state.isLoading = false;
    },
    statusCreateCommentSuccess(state, action) {
      const participants = action.payload;
      const d = new Date();
      const params = {
        fb_comment_id: participants.id,
        message: participants.message,
        post_id: participants.post_id,
        is_sending: 1,
        parent_id: 0,
        is_child: 0
      }
      state.comments = [params, ...state.comments];
      state.isLoading = false;
    },
    statusCreateCommentRepliesSuccess(state, action) {
      const participants = action.payload;
      const d = new Date();
      const params = {
        fb_comment_id: participants.id,
        message: participants.message,
        //post_id: participants.post_id,
        is_sending: 1,
        parent_id: participants.comment_id,
        is_child: 1
      }
      state.commentReplies = [params, ...state.commentReplies];
      state.isLoading = false;
    },
    statusReceiPostFromWebhookFacebook(state, action) {
      const participants = action.payload;


    },
    statusReceiCommentFromWebhookFacebook(state, action) {
      const participants = action.payload;
      var index = state.comments.findIndex(function (comment) {
        return comment.fb_comment_id === participants.fb_comment_id;
      });
      var index_post = -1;
      state.posts = state.posts.map(function (post, index_current) {
        if (post.post_id === participants.post_id) {
          post.is_read = 0;
          post.updated_time = participants.updated_time
          post.updated_at = participants.updated_at
          index_post = index_current
        }
        return post;
      });
      if (index_post != -1) {
        var newPosts = state.posts;
        var temp = newPosts[index_post];
        delete newPosts[index_post];
        newPosts.unshift(temp);
        state.posts = newPosts;
      }
      if (index !== -1) {
        // delete  state.comments[index];
        // state.comments.unshift(participants);
        state.comments[index] = participants
      } else {
        state.comments.unshift(participants)
      }

    },
    statusDeletePostSuccess(state, action) {
      const participants = action.payload;
      state.posts = state.posts.filter(post => post.post_id != participants.post_id);
    },
    statusReceiCommentRepliesFromWebhookFacebook(state, action) {
      const participants = action.payload;

      var index = state.commentReplies.findIndex(function (comment) {
        return comment.fb_comment_id === `${participants.parent_id}_${participants.comment_id}` ||   comment.fb_comment_id === participants.fb_comment_id ;
      });
      var index_post = -1;
      state.posts = state.posts.map(function (post, index_current) {
        if (post.post_id === participants.post_id) {
          post.is_read = 0;
          post.updated_time = participants.updated_time
          post.updated_at = participants.updated_at
          index_post = index_current
        }
        return post;
      });
      if (index_post != -1) {
        var newPosts = state.posts;
        var temp = newPosts[index_post];
        delete newPosts[index_post];
        newPosts.unshift(temp);
        state.posts = newPosts;
      }
      if (index !== -1) {
        state.commentReplies[index] = participants
      } else {
        state.commentReplies.unshift(participants)
      }
    }
  }
});

// Reducer
export default slice.reducer;

export function getListPost(params) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      const response = await apiFacebook.posts(params);
      dispatch(slice.actions.statusGetPostsSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function handleDeletePost(params) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      dispatch(slice.actions.statusDeletePostSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getComments(params) {
  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {
      const response = await apiFacebook.comments(params);
      dispatch(slice.actions.statusGetCommentSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCommentsReply(params) {
  return async (dispatch) => {
    const response = await apiFacebook.viewReplies(params);
    dispatch(slice.actions.statusGetViewReplieSuccess(response.data.data));
    // dispatch(slice.actions.startLoading());
    try {


    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getMoreMesageConversation(params) {

  return async (dispatch) => {
    //dispatch(slice.actions.startLoading());
    try {


    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function sendComment(params) {
  return async (dispatch) => {
    try {
      const response = await apiFacebook.createComment(params);
      dispatch(slice.actions.statusCreateCommentSuccess({ id: response.data.data.id, post_id: params.post_id, message: params.message }));

    } catch (error) {

    }
  };
}

export function sendCommentReply(params) {
  return async (dispatch) => {
    const response = await apiFacebook.createReplyComment(params);
    dispatch(slice.actions.statusCreateCommentRepliesSuccess({ id: response.data.data.id, comment_id: params.comment_id, message: params.message }));
    try {

    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function onSelectedPost(selectedPost) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.statusSelectedPostSuccess(selectedPost));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function receiPostFromWebhookFacebook(selectedPost) {
  return async (dispatch) => {

    try {
      //dispatch(slice.actions.statusSelectedPostSuccess(selectedPost));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function receiCommentFromWebhookFacebook(data) {
  return async (dispatch) => {

    try {
      dispatch(slice.actions.statusReceiCommentFromWebhookFacebook(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function receiCommentRepliesFromWebhookFacebook(data) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.statusReceiCommentRepliesFromWebhookFacebook(data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function onDeletePost(params) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.statusDeletePostSuccess(params));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


// ----------------------------------------------------------------------




